import { PaymentTermReference } from '../../../../types/PaymentTermReference';
import { usePaymentTermsFormat } from '../../../common/hooks/usePaymentTermsFormat';

interface PaymentTermsDisplayProps {
    paymentTermReference: PaymentTermReference;
    paymentTermReferenceDays?: number;
}

export const PaymentTermsDisplay = ({ paymentTermReference, paymentTermReferenceDays }: PaymentTermsDisplayProps) => {
    const formatPaymentTerms = usePaymentTermsFormat();

    return formatPaymentTerms(paymentTermReference, paymentTermReferenceDays);
};
